module.exports = __webpack_public_path__ + "img/hr-puberty-decal-04.6b3d08da.png";